











import { Component, Prop, Vue } from "vue-property-decorator";

// Enums/Data
import { ClientRoutes } from "@/data/enums/router";

// Types
import { IClient } from "@/models/clients";

@Component({
  components: {
    "child-accounts-listing-component": () =>
      import("@/components/app/global/client/childAccountsListingComp.vue")
  }
})
export default class ClientChildAccountsView extends Vue {
  // Props

  @Prop({ required: true })
  public client!: IClient;

  // Life-cycle methods

  public created() {
    if (!this.$store.getters["data/clients/showChildAccounts"](this.client.id))
      this.$router.push({ name: ClientRoutes.ACCOUNT_PROFILE });
  }
}
